// Tiny localStorage-backed preferences. Synchronous, no backend round-trip.
const KEY = "arloseo.milestone_toasts_disabled";

export function milestoneToastsEnabled() {
  if (typeof window === "undefined") return true;
  return localStorage.getItem(KEY) !== "1";
}

export function setMilestoneToastsEnabled(enabled) {
  if (typeof window === "undefined") return;
  if (enabled) localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, "1");
}
